import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { RecommendationProvider } from "./contexts/recommendation-context";
import { QueryClientProvider, QueryClient } from "react-query";
import { BrowserRouter as Router } from "react-router-dom";
import { GlobalStyle } from "./styles/globalStyles";
import "bootstrap/dist/css/bootstrap-reboot.min.css";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: false,
      retryOnMount: false,
    },
  },
});

ReactDOM.render(
  <React.StrictMode>
    <Router>
      <QueryClientProvider client={queryClient}>
        <RecommendationProvider>
          <GlobalStyle />
          <App />
        </RecommendationProvider>
      </QueryClientProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById("root"),
);
